import { render, staticRenderFns } from "./modelContractMview.vue?vue&type=template&id=f565dfee&"
import script from "./modelContractMview.vue?vue&type=script&lang=js&"
export * from "./modelContractMview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports